import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../api';

export const fetchPaymentsReconciliation = createAsyncThunk(
  'paymentsReconciliation/fetch',
  (params, { rejectWithValue }) => {
    return api
      .get('/cardStatementTransactions/reconciliation', { params })
      .then((response) => response.data)
      .catch((err) => rejectWithValue(err.response?.data || err.message));
  }
);

const initialState = {
  data: [],
  error: null,
  isLoading: false,
  lastQuery: null,
};

const paymentsReconciliationSlice = createSlice({
  name: 'paymentsReconciliation',
  initialState,
  reducers: {
    clearPaymentsReconciliation: (state) => {
      state.data = [];
      state.error = null;
      state.lastQuery = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPaymentsReconciliation.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.lastQuery = action.meta.arg;
    });

    builder.addCase(fetchPaymentsReconciliation.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });

    builder.addCase(fetchPaymentsReconciliation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || action.error.message;
    });
  },
});

export const { clearPaymentsReconciliation } = paymentsReconciliationSlice.actions;

export default paymentsReconciliationSlice.reducer;
